import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewFindingsQueryVariables = Types.Exact<{
  jobId: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewFindingsQuery = { __typename?: 'query_root', get_plan_review_findings: { __typename?: 'PlanReviewFindingsResult', is_locked: boolean, passed_count: number, needs_attention_count: number, findings: Array<{ __typename?: 'PlanReviewFindingOutput', id: any, job_id: any, requirement_id?: any | null, document_id?: any | null, rule_id?: string | null, category?: string | null, status: string, severity?: string | null, confidence?: number | null, title?: string | null, summary: string, corrective_action?: string | null, sheet_reference?: string | null, page_number?: number | null, page_reference?: string | null, priority_rank?: number | null, created_at: string, category_record?: { __typename?: 'PlanReviewFindingCategoryOutput', id: any, name: string, sort_order?: number | null } | null, requirement?: { __typename?: 'PlanReviewFindingRequirementOutput', id: any, code?: string | null, title?: string | null, description?: string | null, requirement_type?: string | null, source?: string | null, section?: string | null, source_url?: string | null, category_record?: { __typename?: 'PlanReviewFindingCategoryOutput', id: any, name: string } | null, plan_review_requirement_code_sections: Array<{ __typename?: 'PlanReviewFindingRequirementCodeSectionOutput', code_section_id: any, citation_text?: string | null, code_section?: { __typename?: 'PlanReviewFindingCodeSectionOutput', id: any, section_number: string, title?: string | null, page_number?: number | null, code_book?: { __typename?: 'PlanReviewFindingCodeBookOutput', id: any, abbreviation: string, edition_year?: number | null, book_type?: string | null, source_file_url?: string | null } | null } | null }>, cross_referenced_sections: Array<{ __typename?: 'PlanReviewCrossReferenceSectionOutput', code_section_id: any, section_number: string, title?: string | null, page_number?: number | null, referenced_by: Array<string>, code_book: { __typename?: 'PlanReviewCrossReferenceCodeBookOutput', id: any, abbreviation: string, edition_year?: number | null, book_type?: string | null, source_file_url?: string | null } }> } | null, document?: { __typename?: 'PlanReviewFindingDocumentOutput', id: any, file_name?: string | null } | null, plan_review_citations: Array<{ __typename?: 'PlanReviewFindingCitationOutput', id: any, tier?: string | null, source?: string | null, section?: string | null, source_url?: string | null, page_numbers?: any | null, created_at?: string | null }>, plan_review_feedbacks: Array<{ __typename?: 'PlanReviewFindingFeedbackOutput', id: any, user_id: string, decision?: string | null, error_attribution?: string | null, comment?: string | null, created_at: string, updated_at: string }> }> } };


export const GetPlanReviewFindingsDocument = gql`
    query getPlanReviewFindings($jobId: uuid!) {
  get_plan_review_findings(job_id: $jobId) {
    is_locked
    passed_count
    needs_attention_count
    findings {
      id
      job_id
      requirement_id
      document_id
      rule_id
      category
      category_record {
        id
        name
        sort_order
      }
      status
      severity
      confidence
      title
      summary
      corrective_action
      sheet_reference
      page_number
      page_reference
      priority_rank
      created_at
      requirement {
        id
        code
        title
        description
        requirement_type
        source
        section
        source_url
        category_record {
          id
          name
        }
        plan_review_requirement_code_sections {
          code_section_id
          citation_text
          code_section {
            id
            section_number
            title
            page_number
            code_book {
              id
              abbreviation
              edition_year
              book_type
              source_file_url
            }
          }
        }
        cross_referenced_sections {
          code_section_id
          section_number
          title
          page_number
          referenced_by
          code_book {
            id
            abbreviation
            edition_year
            book_type
            source_file_url
          }
        }
      }
      document {
        id
        file_name
      }
      plan_review_citations {
        id
        tier
        source
        section
        source_url
        page_numbers
        created_at
      }
      plan_review_feedbacks {
        id
        user_id
        decision
        error_attribution
        comment
        created_at
        updated_at
      }
    }
  }
}
    `;

/**
 * __useGetPlanReviewFindingsQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewFindingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewFindingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewFindingsQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetPlanReviewFindingsQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables> & ({ variables: GetPlanReviewFindingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>(GetPlanReviewFindingsDocument, options);
      }
export function useGetPlanReviewFindingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>(GetPlanReviewFindingsDocument, options);
        }
export function useGetPlanReviewFindingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>(GetPlanReviewFindingsDocument, options);
        }
export type GetPlanReviewFindingsQueryHookResult = ReturnType<typeof useGetPlanReviewFindingsQuery>;
export type GetPlanReviewFindingsLazyQueryHookResult = ReturnType<typeof useGetPlanReviewFindingsLazyQuery>;
export type GetPlanReviewFindingsSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewFindingsSuspenseQuery>;
export type GetPlanReviewFindingsQueryResult = Apollo.QueryResult<GetPlanReviewFindingsQuery, GetPlanReviewFindingsQueryVariables>;